import { createContext, useContext, useMemo } from 'react';

interface AccordionContextType {
	allowMultiple: boolean;
	expandedItemKeys: string[];
	changeSelection: (eventKeys: string) => void;
	isAccordionItemExpanded: (eventKeys: string) => boolean;
}

type AccordionProviderProps = AccordionContextType & {
	children: React.ReactNode;
}

const AccordionContext = createContext<AccordionContextType>({} as AccordionContextType);

export function AccordionProvider({ 
	allowMultiple, 
	expandedItemKeys, 
	changeSelection, 
	isAccordionItemExpanded,
	children 
}: AccordionProviderProps) {
	const value = useMemo(() => ({
		allowMultiple,
		expandedItemKeys,
		changeSelection,
		isAccordionItemExpanded
	}), [allowMultiple, expandedItemKeys, changeSelection, isAccordionItemExpanded]);

	return (
		<AccordionContext.Provider value={value}>
			{children}
		</AccordionContext.Provider>
	);
}

export const useAccordionContext = () => useContext(AccordionContext);